(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vale-cart-dialog"]) return;
  try {
    
(() => {
  let pending = false;
  let opener;
  const root = window.Shopify?.routes?.root || '/';
  function closeDialog(){const dialog=document.querySelector('[data-vh-cart-dialog]');if(dialog?.open)dialog.close();opener?.focus();}
  document.addEventListener('click',event=>{if(event.target.closest('[data-vh-close]'))closeDialog();});
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!form.matches('form[data-vh-add]'))return;
    event.preventDefault();
    if(pending)return;
    const button=event.submitter || form.querySelector('button[type=submit]');
    const dialog=document.querySelector('[data-vh-cart-dialog]');
    if(!dialog){form.submit();return;}
    pending=true;opener=button;
    const original=button.textContent;
    const alert=document.querySelector('[data-vh-cart-alert]');
    alert.hidden=true;
    button.disabled=true;button.textContent=dialog.dataset.adding;
    let added=false;
    try{
      const body=new FormData(form);body.delete('return_to');
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:dialog.dataset.error);
      added=true;
      if(window.location.pathname.replace(/\/$/,'').endsWith('/cart')){window.location.assign(root+'cart?vale_added=1');return;}
      const url=new URL(root,window.location.origin);url.searchParams.set('section_id',dialog.dataset.section);
      const rendered=await fetch(url.toString());if(!rendered.ok)throw new Error('render');
      const documentFragment=new DOMParser().parseFromString(await rendered.text(),'text/html');
      const fresh=documentFragment.querySelector('[data-vh-cart-dialog]');if(!fresh)throw new Error('render');
      dialog.innerHTML=fresh.innerHTML;
      const cartResponse=await fetch(root+'cart.js');if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('.vh-bag span').forEach(el=>el.textContent=cart.item_count);}
      if(!dialog.open)dialog.showModal();
    }catch(error){
      if(added){window.location.assign(root+'cart?vale_added=1');return;}
      alert.textContent=error.message || dialog.dataset.error;alert.hidden=false;
    }finally{pending=false;button.disabled=false;button.textContent=original;}
  });
  const params=new URLSearchParams(window.location.search);
  if(params.get('customer_posted')==='true'){const dialog=document.querySelector('[data-vh-cart-dialog]');if(dialog){const details=dialog.querySelector('.vh-newsletter');details.open=true;const form=details.querySelector('form');const success=document.createElement('p');success.setAttribute('role','status');success.textContent=dialog.dataset.success;form.replaceWith(success);dialog.showModal();}}
  if(params.get('vale_added')==='1')document.querySelector('[data-vh-cart-dialog]')?.showModal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vale-halloween-header"]) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-vh-marquee-toggle]');if(!button)return;const paused=button.closest('[data-vh-marquee]').classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.play:button.dataset.pause);button.textContent=paused?'▶':'Ⅱ';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vale-pet-product"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-vh-variant]'))return;const destination=new URL(window.location.href);destination.searchParams.set('variant',event.target.value);window.location.assign(destination.toString());});

  } catch(e) { console.error(e); }
})();
})();
